(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37805],{

/***/ 90407:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-security/assessment",
      function () {
        return __webpack_require__(4534);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var containers_Assessment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22445);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (containers_Assessment__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [53662,24168,84602,57330,6778,13107,19386,27001,49774,92888,40179], function() { return __webpack_exec__(90407); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);